import ModelsLoading from './ModelsLoading';

export default ModelsLoading;
